























import Vue from "vue";
import Component from "vue-class-component";
import { CrudService } from "../core/services/crudService";
import { Settings, SettingsService } from "../core/services/configService";
import { ProgramPackTexts } from "./programPackTexts";
import ProgramPage from "../components/programs/ProgramPage.vue";
import ProgramCard from "../components/programs/ProgramCard.vue";
import ProgramMedia from "../components/programs/ProgramMedia.vue";
import ProgramsInProgress from "../components/programs/ProgramsInProgress.vue";

@Component({
  components: { ProgramPage, ProgramCard, ProgramMedia, ProgramsInProgress },
})
export default class ProgramPacksPage extends Vue {
  programs: any[] = [];
  loaded: boolean = false;
  texts = ProgramPackTexts;

  get emptyText(): string {
    return this.loaded && this.programs.length === 0 ? this.$t("There are no programs available").toString() : "";
  }

  t(key: string): string {
    return this.$t(key).toString();
  }

  async mounted() {
    new SettingsService().setPageTitle(this.t("Programs"));
    const data = await new CrudService().httpGet(`${Settings.HostName}/api/publicprogrampacks/list`);
    this.programs = data && data.ok ? data.data : [];
    this.loaded = true;
  }
}
